import { http } from '@/utils/service.js'
export * from '@/utils/config.js'

// 查询字典值数据
export const getSystemDictData = (data) => {
  return http({
    url: 'visitsAdmin/cloudService/web/other/getSystemDictData',
    data
  })
}
// 获取题目数据
export const getProblemsVO = () => {
  return http({
    url: 'visitsAdmin/cloudService/web/problem/getProblemsVO'
  })
}
// 访客预约详情
export const visitorSubDetail = (data) => {
  return http({
    url: 'visitsAdmin/cloudService/web/visitor/detail',
    data
  })
}